<template>
 <section class="participants-container">
   <h3
     v-if="title"
     class="participants__title">
     {{ title }}
   </h3>
   <form
     @submit.prevent="handleSubmit"
     class="participants-form">
     <people-list
       class="people-list"
       :users="eventSelectedContacts"
       :show-delete-button="!disableDeleting"
       :enable-access-check="false"
       :check-user-amount="false"
       message="dont show"
       :disable-focus="true"
       :show-add-button="false"
       :show-user-phone="true"
       @deleteUser="deleteUser"
       @changeMoney="changeMoney"
       :show-money-input="transaction === 'split purchase'"
       :even-for-rest-total="transaction === 'split purchase' ? null : evenForRestTotal"
     />
     <add-human-button
       v-if="!disableAdding"
       variant="add"
       class="add-participants-button"
       @clicked="toggleAddParticipants"
     />
   </form>
 </section>
</template>

<script>
/* eslint-disable arrow-body-style */
import { mapState } from 'vuex';
import {
  SET_FINAL_EVENT_SELECTED_CONTACTS,
  DELETE_EVENT_SELECTED_CONTACTS_REQUEST,
} from '@/store/user/types';
import { SET_SPLIT_PURCHASE_INFO } from '@/store/operations/types';
import PeopleList from '../../components/PeopleList/PeopleList';
import AddHumanButton from '../../components/AddHumanButton/AddHumanButton';

export default {
  name: 'ParticipantsForm',
  components: {
    AddHumanButton,
    PeopleList,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t('CP.participants');
      },
    },
    evenForRestTotal: {
      type: Number,
      default: null,
    },
    disableAdding: {
      type: Boolean,
      default: false,
    },
    disableDeleting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      splitUsersMoney: [],
      transactionSum: '',
    };
  },
  mounted() {
    this.splitUsersMoney = this.purchaseInfo.splitUsersMoney
      || this.eventSelectedContacts.map((contact) => (
        { phone: contact.phone, money: 0 }
      ));
    this.transactionSum = this.purchaseInfo.transactionSum || '';
  },
  watch: {
    eventSelectedContacts(newEventSelectedContacts) {
      this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, newEventSelectedContacts);
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      userPhone: (state) => state.user.user.phone,
      transaction: (state) => state.operations.selectedOperation,
      purchaseInfo: (state) => state.operations.purchaseInfo,
      eventSelectedContacts: (state) => {
        // if (state.operations.selectedOperation === 'i purchased them') {
        //   return state.user.eventSelectedContacts
        //     .filter((contact) => contact.uid !== state.user.user.user);
        // }
        return state.user.eventSelectedContacts;
      },
      finalEventSelectedContacts: (state) => {
        // if (state.operations.selectedOperation === 'i purchased them') {
        //   return state.user.finalEventSelectedContacts
        //     .filter((contact) => contact.uid !== state.user.user.user);
        // }
        return state.user.finalEventSelectedContacts;
      },
    }),
  },
  methods: {
    changeMoney(usersMoney) {
      const index = this.splitUsersMoney
        .findIndex((userMoney) => userMoney.phone === usersMoney.phone);
      if (index === -1) {
        this.splitUsersMoney.push(usersMoney);
      } else {
        this.splitUsersMoney.splice(index, 1, usersMoney);
      }
      this.transactionSum = this.splitUsersMoney.reduce((sum, user) => {
        // eslint-disable-next-line no-param-reassign
        sum += +user.money;
        return sum;
      }, 0) || '';
      this.handleSubmit();
    },
    cancelSubmit() {
      this.$bvModal.hide('participants');
    },
    handleSubmit() {
      this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, this.eventSelectedContacts);
      if (this.transaction === 'split purchase') {
        // eslint-disable-next-line prefer-const
        let { splitUsersMoney, transactionSum } = this;
        splitUsersMoney = splitUsersMoney.filter((splitUser) => (
          !!this.eventSelectedContacts
            .find((selectedContact) => selectedContact.phone === splitUser.phone)
        ));
        this.$store.commit(SET_SPLIT_PURCHASE_INFO, {
          splitUsersMoney: [...splitUsersMoney],
          transactionSum,
        });
      }
      this.$bvModal.hide('participants');
    },
    deleteUser(user) {
      this.$store.dispatch(DELETE_EVENT_SELECTED_CONTACTS_REQUEST, user);
      if (this.transaction === 'split purchase') {
        this.splitUsersMoney = this.splitUsersMoney
          .filter((splitUser) => (
            splitUser.phone !== user.phone
          ));
        this.transactionSum = this.splitUsersMoney.reduce((sum, splitUser) => {
          // eslint-disable-next-line no-param-reassign
          sum += +splitUser.money;
          return sum;
        }, 0) || '';
        this.$store.commit(SET_SPLIT_PURCHASE_INFO, {
          splitUsersMoney: [...this.splitUsersMoney],
          transactionSum: this.transactionSum,
        });
      }
    },
    toggleAddParticipants(addedUsers) {
      if (this.transaction === 'split purchase') {
        // eslint-disable-next-line prefer-const
        let { splitUsersMoney } = this;
        if (addedUsers && addedUsers.length) {
          splitUsersMoney = splitUsersMoney
            .concat(
              addedUsers.map((addedUser) => ({ phone: addedUser.phone, money: 0 })),
            );
          this.splitUsersMoney = splitUsersMoney;
          this.transactionSum = this.splitUsersMoney.reduce((sum, user) => {
            // eslint-disable-next-line no-param-reassign
            sum += +user.money;
            return sum;
          }, 0) || '';
        }
      }
      this.$bvModal.show('add-participants');
    },
  },
};
</script>

<style scoped>
  .participants-container {
    color: var(--text-main-color);
  }
  .participants-form {
    padding: 0 calc(32px - 1rem);
  }
  .participants__title {
    margin: 0 0 26px;
  }
  .people-list {
    margin: 0 0 30px;
    max-height: 50vh;
  }
  .add-participants-form {
    padding: 0;
  }
</style>
